import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast';
import { updateProduct as updateProductAPI} from 'services/apiProduct';

const useUpdateProduct = () => {
    const queryClient = useQueryClient();

    const{isPending:isUpdating,isSuccess:isUpdated,mutate: updateProduct} = useMutation({
        mutationFn: updateProductAPI,
        onSuccess:(data)=>{
            queryClient.setQueryData(['editedProduct'],data)
            queryClient.invalidateQueries({queryKey:['productList']})
            queryClient.invalidateQueries({queryKey:['initData']})
            toast.success("Product updated Sucessfully")
        },
        onError:(error)=>{
            console.log("Error occurred while updating orders",error)
            if(error?.data && typeof error.data === 'object'){
                for (const key in error.data){
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg)
                }
            }else{
                toast.error(error.message || "Something went wrong")
            }
        }
    })

    return {isUpdating,isUpdated,updateProduct}
}

export default useUpdateProduct
